import produce from 'immer';

import type { ClubSeasonUserStats } from '@swf/generated/types/api/v1-preview/SwHomeGames';
import { PKR_INITIAL_STATE } from '@swf/poker';

export const setClubSeasonStats = (
  state = PKR_INITIAL_STATE,
  { clubId, stats }: { clubId: string; stats: ClubSeasonUserStats[] }
) =>
  produce(state, (draft) => {
    draft.clubSeasonStatsById[clubId] = stats.map((stat) =>
      stat.qualifiedGames === 0 ? { ...stat, rank: '-' } : stat
    );
  });
